import React, { forwardRef } from "react";

import FormField from "./Form.Field";
import FormHelp from "./Form.Help";
import FormWrapper from "./Form.Wrapper";
import FormValidation from "./Form.Validation";

import * as styles from "./Checkbox.styles";

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  help?: React.ReactNode;
  children: React.ReactNode;
  fieldProps?: Record<string, unknown>;
  isInvalid?: boolean;
  errorMessage?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  id,
  name,
  help,
  children,
  fieldProps = {},
  checked,
  defaultChecked,
  isInvalid = false,
  errorMessage,
  ...checkboxProps
}, ref) => {

  const isControlled = checked !== undefined;
  const fieldId = id || `checkbox-${name || "default"}`;

  return (
    <FormField
      className="field-checkbox"
      {...fieldProps}>

      <FormWrapper>

        <input
          ref={ref}
          id={fieldId}
          name={name}
          {...(isControlled ? { checked } : { defaultChecked })}
          css={styles.input}
          {...checkboxProps}
          type="checkbox" />

        <label
          css={styles.label}
          htmlFor={fieldId}>
          <span>{children}</span>
        </label>

      </FormWrapper>

      {help ? <FormHelp>{help}</FormHelp> : null}

      <FormValidation
        errorMessage={errorMessage || ""}
        isVisible={isInvalid} />

    </FormField>
  );
});

Checkbox.displayName = "Checkbox";

export default Checkbox;
